const warn = {
  noSupport: '暂不支持该功能',
};
export default warn;
